import { render, staticRenderFns } from "./PddSortTabs.vue?vue&type=template&id=69808f29&scoped=true&"
import script from "./PddSortTabs.vue?vue&type=script&lang=js&"
export * from "./PddSortTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69808f29",
  null
  
)

export default component.exports